import script from "./ObjectivesTableLoader.vue?vue&type=script&setup=true&lang=js"
export * from "./ObjectivesTableLoader.vue?vue&type=script&setup=true&lang=js"

import "./ObjectivesTableLoader.vue?vue&type=style&index=0&id=9c1ff99c&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-9c1ff99c"]])

export default __exports__